<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Reports
        </h1>
      </div>
    </section>
    <section>
      <div class="tw-mx-2">
        <div class="tw-text-xs">
          <TableServer :options="options" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    TableServer: () => import('@/components/_vue/TableServer'),
  },

  data() {
    return {
      options: {
        buttons: 'admin-actions',
        url: '/api/admin/reports',
        name: 'reports',
        columns: [
          'actions',
          // 'reporter_user_id',
          // 'reported_user_id',
          'reportedName',
          'reason',
          'reporterName',
          'createdAt',
        ],
        tableOptions: {
          perPage: 100,
          headings: {
            reporterName: 'Reported By',
            received_requests_count: 'Received',
            matches_count: 'Matches',
            messages_count: 'Messages',
            travel_plans_count: 'Plans',
          },
          orderBy: {
            column: 'createdAt',
            ascending: false,
          },
          filterable: ['name', 'email'],
        },
      },
    };
  },
};
</script>
